import { Component, computed, inject, input } from "@angular/core"
import { RouterLink } from "@angular/router"
import { AppRoute } from "@app-types/appRoute"
import { RouteService } from "@services/route.service"
import { isEqual } from "lodash"

@Component({
    selector: 'vco-nav-item',
    imports: [RouterLink],
    template: `
        <li class="nav-item" [class.active]="active()">
            <a [routerLink]="active() ? undefined : routerLink()" class="flex items-center gap-2">
                <i class="material-icons-outlined">{{icon()}}</i>
                {{label()}}
            </a>
        </li>
    `,
    styles: [`
        .nav-item {
            list-style: none;
            margin: 0.5rem 0;
            user-select: none;
        }
        .nav-item a {
            text-decoration: none;
        }
        .nav-item.active {
            background-color: var(--color-primary);
            color: var(--color-textLightest)
        }
    `]
}) export class NavItemComponent {
    readonly label = input.required<string>()
    readonly routerLink = input.required<AppRoute>()
    readonly icon = input<string>('description')

    private readonly _routeService = inject(RouteService)
    readonly active = computed(() => isEqual(this._routeService.currentRoute().path, this.routerLink()))
}